<template>
  <span class="icon" />
</template>
<script lang="ts" setup>
import { computed } from 'vue';
interface GraphicProps {
  src: String;
  size?: number;
}
const props = defineProps({
  src: null,
  size: { default: 2.5 }
});
const url = computed(() => {
  return `url(${props.src})`;
});
const csssize = computed(() => {
  return `${props.size}rem`;
});
</script>
<style lang="scss" scoped>
.icon {
  display: block;
  width: v-bind(csssize);
  height: v-bind(csssize);
  background-image: v-bind(url);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
